import { render } from "./DeclareLimitCheck.vue?vue&type=template&id=bd642776"
import script from "./DeclareLimitCheck.vue?vue&type=script&lang=js"
export * from "./DeclareLimitCheck.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__